export type ResolvedType<T> = T extends (...args: any) => Promise<infer U>
  ? U
  : never;

export function valueExists<T>(arg: T): arg is NonNullable<T> {
  return arg !== undefined && arg !== null;
}
